var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"item"},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('button',{staticClass:"view-btn",on:{"click":function($event){return _vm.$emit('on-view')}}},[_vm._v(" "+_vm._s(_vm.$t("components.view"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }